import {useNavigate} from "react-router-dom";
import React, {useState} from "react";
import {storage} from "../utils/localstorage";
import {Alert, Button} from "@mui/material";

import css from '../css/notice.module.css';
import {AppComponent} from "../App";
import {post} from "../utils/post";

export const Notice = () => {
    const navigate = useNavigate();
    const [show, setShow] = useState({days: -1});

    const getText = () => {
        if (show.days < 1) return `Сегодня истекает срок подписки`;
        if (show.days > 4) return `До истечения срока подписки осталось <b>${show.days}</b> дней`;
        if (show.days > 1) return `До истечения срока подписки осталось <b>${show.days}</b> дня`;
        if (show.days < 2) return `До истечения срока подписки остался <b>${show.days}</b> день`;
    }

    AppComponent.SetNotice = ({isTrial, days, date, noticeDays}) => setShow({isTrial, date, days, noticeDays});

    const hide = () => {
        setShow({days: -1});
        storage("notice", show.date);
    }

    if (storage("notice") === show.date) return;
    if (show.days < 0) return;
    if (show.days > show.noticeDays) return;

    const renewTariff = async () => {
        hide();
        const {invoice} = await post({method: "invoiceCreate", renew: true}, true);
        navigate(`/payment/${invoice.id}/`);
    }

    const chooseTariff = async () => {
        hide();
        navigate(`/payment/`);
    }

    return (
        <div className={css.notice}>
            <Alert elevation={3} severity={"warning"} onClose={hide}>
                <span dangerouslySetInnerHTML={{__html: getText()}}/>
                {show.isTrial ? (
                    <Button id={"chooseTariff"} onClick={chooseTariff} variant={"contained"} size={"small"}>Выбрать тариф</Button>
                ) : (
                    <Button id={"renewTariff"} onClick={renewTariff} variant={"contained"} size={"small"}>Продлить</Button>
                )}
            </Alert>
        </div>
    )
}
